import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/staffs/profiles/new/Page";

export const PATH = "/settings/staffs/new";

const Home: NextPage = () => (
	<>
		<NskHead title="担当者追加" />
		<Component />
	</>
);

export default Home;
